import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { contextCloseMode_Force, provideInfoContextKey_Score } from '../../../../../modules/provide-info/types.js';
import { ModuleFE_ProvideInfo } from '../../../../../modules/provide-info/ModuleFE_ProvideInfo.js';
import { Component_PrettyPrint_Expression } from '@app/hcs-frontend/ui-components';
import { ModuleFE_Advisor_Expression, ModuleFE_Advisor_Value, ModuleFE_Advisor_Variable } from '@app/advisor-frontend';
import './Component_ProvideInfoV2_Score.scss';
import { voidFunction } from '@nu-art/ts-common';
import { Component_ProvideInfo_Input } from '../Component_ProvideInfo_Input/Component_ProvideInfo_Input.js';
import { FadeScrollWrapper } from '@app/styles';
import { Component_ProvideInfoV2_Controls } from '../../footer/Component_ProvideInfoV2_Controls/Component_ProvideInfoV2_Controls.js';
import { calculateActualValueMap, calculatePartialValueMap, calculateSuggestedValueMap } from '../utils.js';
export class Component_ProvideInfoV2_Score extends ComponentSync {
    __onProvideInfoContextChange = voidFunction;
    __onProvideInfoContextUpdate = (context) => this.forceUpdate();
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.contextData = nextProps.contextData;
        return state;
    }
    //######################### Logic #########################
    onVariableIdSelected = (variableId) => {
        ModuleFE_ProvideInfo.context.current.selectVariable(variableId);
    };
    getScoreValue = () => {
        const result = this.state.contextData.calculationResult?.['E'];
        return typeof result === 'number' ? result : undefined;
    };
    //######################### Render #########################
    render() {
        const data = this.state.contextData;
        const actualValueMap = calculateActualValueMap(data);
        const suggestedValueMap = calculateSuggestedValueMap(data);
        const partialValueMap = calculatePartialValueMap(data);
        const inputKey = `score-${data.expression._id}`;
        return _jsxs(_Fragment, { children: [_jsx(FadeScrollWrapper, { className: 'provide-info__score', children: _jsxs(LL_V_L, { className: 'provide-info__score__inner', children: [this.render_Header(), _jsx(Component_PrettyPrint_Expression, { modules: {
                                    variable: ModuleFE_Advisor_Variable,
                                    value: ModuleFE_Advisor_Value,
                                    expression: ModuleFE_Advisor_Expression,
                                }, expression: data.expression, guidelines: true, interactive: true, interactiveProperties: {
                                    calculationResult: data.calculationResult,
                                    actualValueMap: actualValueMap,
                                    suggestedValueMap: suggestedValueMap,
                                    partialValueMap: partialValueMap,
                                    onVariableSelected: varId => this.onVariableIdSelected(varId),
                                    selectedVariableId: data.input.varId,
                                    valueTree: data.valueTree,
                                } })] }) }), _jsx(Component_ProvideInfoV2_Controls, { contextData: this.state.contextData, type: provideInfoContextKey_Score }), _jsx(Component_ProvideInfo_Input, { contextData: this.state.contextData }, inputKey)] });
    }
    render_Header = () => {
        if (ModuleFE_ProvideInfo.context.current.isBaseContext())
            return;
        const value = this.getScoreValue();
        const title = this.state.contextData.expression.label ?? 'N/A';
        return _jsxs(LL_H_C, { className: 'provide-info__score__header', children: [_jsxs(LL_H_C, { className: 'provide-info__score__header-main', children: [_jsx("div", { className: 'provide-info__score__title', children: title }), _jsx("div", { className: 'provide-info__score__value', children: value ?? '-' })] }), _jsxs(LL_H_C, { className: 'provide-info__score__header-actions', children: [_jsx(Button, { variant: 'secondary', onClick: () => ModuleFE_ProvideInfo.context.current.close(contextCloseMode_Force), children: "Cancel" }), _jsx(Button, { variant: 'primary', onClick: () => this.state.contextData.findings.save(), children: "Save" })] })] });
    };
}
//# sourceMappingURL=Component_ProvideInfoV2_Score.js.map